import { createContext } from 'react';
import { type OverridedMixpanel } from '#mixpanel';

export const MixpanelContext = createContext<OverridedMixpanel | undefined>(
  undefined
);
MixpanelContext.displayName = 'MixpanelContext';
